export default __webpack_public_path__ + "static/media/intro_sql.7525cbc5.svg";